import { Button, Container, Step, StepLabel, Stepper } from "@material-ui/core";
import { useEffect, useState } from "react";
import Page1OrderSelect from "./ProductionCreateOrderSelect/Page1OrderSelect";
import Page2ItemSettings from "./ProductionCreateOrderSelect/Page2ItemSettings/Page2ItemSettings";
import { useLocation } from "react-router";
import { getOrderInfo } from "shared/network/order.api";
import { useSelector } from "react-redux";
import { RootState } from "config/store";
import { Item } from "shared/types";

const steps = ["Termék kiválasztás", "Megrendelés összerendelés"];

const ProductionCreate = () => {
  const { tenant } = useSelector((state: RootState) => state.authentication.selectedRelTenant);
  const [activeStep, setActiveStep] = useState(0);
  const [groupCode, setGroupCode] = useState("");

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const linkGroupCode = query.get("groupCode");

  useEffect(() => {
    if (!groupCode && linkGroupCode) {
      setGroupCode(linkGroupCode);
      setActiveStep(1);
    }
  }, [groupCode, linkGroupCode, setGroupCode]);

  return (
    <Container maxWidth="xl">
      {activeStep === 0 && (
        <Page1OrderSelect
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          groupCode={groupCode}
          setGroupCode={setGroupCode}
        />
      )}
      {activeStep === 1 && <Page2ItemSettings groupCode={groupCode} />}
    </Container>
  );
};

export default ProductionCreate;
